/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowARightIcon20Solid = forwardRef('ArrowARightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10.835 4.321a1.25 1.25 0 1 1 1.768-1.767l5.236 5.236a3.125 3.125 0 0 1 0 4.42l-5.236 5.236a1.25 1.25 0 0 1-1.768-1.767l4.428-4.429H2.5a1.25 1.25 0 1 1 0-2.5h12.764l-4.43-4.429Z" })));
});
